<template>
  <div class="NameCard">


    <header class="navbar">
    <section class="navbar-primary">
      <a href="#" class="navbar-brand mr-10">Back</a>
    </section>

    <section class="navbar-section">
      <div class="input-group input-inline">

        <!-- <button class="btn btn input-group-btn">...</button> -->
      </div>
    </section>
  </header>


  <div class="panel" v-if=availableNames>
    <div class="panel-header">
      <div class="panel-title">
        {{currentIndex + 1}} / {{availableNames}}
      </div>
    </div>
    <div class="panel-nav">
      <!-- navigation components: tabs, breadcrumbs or pagination -->
    </div>
    <div class="panel-body">
      <Card
        :name="currentName"
        :rating="rating"
        :addRating="addRating"
        :removeRating="removeRating"
        :addComment="addComment">
      </Card>
    </div>
    <div class="panel-footer">
      <div class="container">
        <div class="columns">
          <div class="column col-6">
            <button :class="[prevAvailable ? '' : 'disabled']" class="btn" @click="prevName()">Prev</button>
          </div>
          <div class="column col-6">
            <button :class="[nextAvailable ? '' : 'disabled']"class="btn" @click="nextName()">Next</button>
          </div>
        </div>
      </div>


    </div>
  </div>

  <div class="empty" v-else>
    <div class="empty-icon">
      <i class="icon icon-people"></i>
    </div>
    <h4 class="empty-title">You have no new names</h4>
    <p class="empty-meta">Add a new name!</p>
    <div class="empty-action">
      <button class="btn btn-primary">On the frontpage</button>
    </div>
  </div>


  </div>
</template>

<script>
import { db } from '../firebase'
const names = db().ref('names')


import Card from './Card'
import { first, size } from 'lodash'
import { userName, User } from '../helper/helper'
import Names from '../models/names'

const namesModel = Names({ namesDb: names })

const notRatedByMe = name => {
  if (name.rating && name.rating[User().get()]) {
    return false
  } else {
    return true
  }
}

const not = bool => !bool

const filters = {
  all: names => names,
  unrated: names => names.filter(notRatedByMe),
  byme: names => names.filter(name => !notRatedByMe(name)),
  favorite: names => names.filter(name => name.hasOwnProperty('favorite'))
  // active: names => names.filter(task => !filterDone(task)),
  // completed: names => names.filter(filterDone)
}

const sort = {

}

export default {
  name: 'hello',
  components: {
    Card,
  },
  props: ['visibility'],
  data() {
    return {
      currentIndex: 0,
      filters,
    };
  },
  computed: {
    filteredNames () {
      return filters[this.visibility](this.names)
    },
    availableNames () {
      return size(this.filteredNames)
    },
    currentName () {
      if (this.currentIndex < size(this.filteredNames)) {
        return this.filteredNames[this.currentIndex]
      } else {
        return 'Too Far'
      }
    },
    prevAvailable() {
      if (this.currentIndex > 0) {
        return true
      } else {
        return false
      }
    },
    nextAvailable() {
      if (this.currentIndex < this.availableNames - 1 ) {
        return true
      } else {
        return false
      }
    },
    rating: function() {
      if (this.currentName && this.currentName.rating && this.currentName.rating[User().get()]) {
        return this.currentName.rating[User().get()]
      } else {
        return -1
      }
    }
  },
  methods: {
    addRating: function (nameKey, rating) {
        // TODO: USER
      return namesModel.addRating(nameKey, User().get(), rating)
      .then(() => {
        this.nextName()
      })

    },
    removeRating: function(nameKey) {
      return namesModel.removeRating(nameKey, User().get())
    },
    addComment: function(nameKey, comment) {
      return namesModel.addComment(nameKey, User().get(), comment)
    },
    prevName: function() {
      this.currentIndex = this.currentIndex - 1
    },
    nextName: function() {
      if (this.nextAvailable) {
        this.currentIndex = this.currentIndex + 1
      } else {

      }
    }
  },
  firebase: {
    names: names
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// NameCard.vue?8e05af40